import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Row, Col, Card, Form, Offcanvas, Button, Image, Modal } from 'react-bootstrap';
import Layout from "../../components/Layout.";
import {ReactComponent as ProfileSvg} from './../../assets/icons/svg/profile.svg';
import {ReactComponent as QuestionSvg} from './../../assets/icons/svg/question.svg';
import dayjs from 'dayjs';
import transaction from "../../actions/transaction";
import { currencyConverter } from "../../utils";
import { toast } from "react-toastify";

export default function CartList() {
   const dataUser = JSON.parse(sessionStorage.getItem('profile'));
   const navigate = useNavigate();
   const [newsList, setNewsList] = useState([]);
   const [detail, setDetail] = useState([]);
   const [showConfirm, setShowConfirm] = useState(false);
   const handleCloseConfirm = () => setShowConfirm(false);
   const handleShowConfirm = () => setShowConfirm(true);
   const [showCancel, setShowCancel] = useState(false);
   const handleCloseCancel = () => setShowCancel(false);
   const handleShowCancel = () => setShowCancel(true);
   const [loading, setLoading] = useState(true);

  useEffect(() => {
   transaction.actions.get_cart().then((res)=>{
      setNewsList(res?.trash_deposit_items)
      setDetail(res)
      setLoading(false)
   });
  },[])

  const onConfirm = () => {
   let data = {
      deposit_id: detail?.id,
      status: 1
   }
   transaction.actions.post_cart(data).then((res)=>{
      handleCloseConfirm();
      setLoading(true)
      transaction.actions.get_cart().then((res)=>{
         setNewsList(res?.trash_deposit_items)
         setDetail(res)
         setLoading(false)
         toast.success('Setor sampah berhasil dikonfirmasi')
      }).catch((err)=>{
         toast.error('Setor sampah gagal dikonfimasi')
         setLoading(false)
      });
   });
  }

  const onCancel = () => {
   let data = {
      deposit_id: detail?.id,
      status: 2
   }
   transaction.actions.post_cart(data).then((res)=>{
      transaction.actions.get_cart().then((res)=>{
         setNewsList(res?.trash_deposit_items)
         setDetail(res)
         handleCloseCancel();
         toast.success('Setor sampah berhasil dibatalkan')
      });
   }).catch((err)=>{
      toast.error('Maaf terjadi kesalahan')
      handleCloseCancel();
   });
  }

  return (
   <Layout active={4} bg="bg-gray">
      <div className="bg-radial-green-short p-4 ">
        <Row className="d-flex align-items-center h-100">
          <h3 className="text-light mb-0">Keranjang</h3>
        </Row>
      </div>

      <div className="p-4">
         <Card className="card-cart border-0 bg-white" style={{marginBottom:'80px'}}>
            <div className="btn-success d-flex align-items-center py-1 px-3">
               <ProfileSvg style={{width:'25px', height:'25px'}}/>
               <div className="ts-sm fw-semibold ms-2 text-light">
                  {dayjs(dataUser?.created_at).format('DD/MMMM YYYY')} - {dataUser?.name}
               </div>
            </div>
            <Card.Body>
               {loading ?
               <div>
                  <div className="skeleton skeleton-card"></div>
               </div>:
               <>
                  {detail ?
                     <div>
                        <span>
                           {newsList?.map((item,key)=>{
                              return (
                              <div key={key}>
                                 <div className="py-3">
                                    <div className="d-flex align-items-center mb-3">
                                       <Image src={item?.metadata?.attributes?.image} width="50px" height="50px" className="btn-radius"/>
                                       <div className="ms-3">
                                          <div className="fw-semibold ts-md text-dark">{item?.metadata?.attributes?.trash_type}</div>
                                          <div className="ts-sm text-secondary">
                                             {item?.metadata?.attributes?.category_name} - {item?.metadata?.name}
                                          </div>
                                       </div>
                                    </div>
                                    <div className="btn-success-opacity p-2">
                                       <table>
                                          <tbody>
                                             <tr>
                                                <td className="ts-sm text-body fw-semibold" width="200px">Berat</td>
                                                <td className="ts-sm text-body fw-semibold">{item?.metadata?.quantity} Kg</td>
                                             </tr>
                                             <tr>
                                                <td className="ts-ssm text-body fw-semibold" width="200px">Harga</td>
                                                <td className="ts-ssm text-body fw-semibold">{currencyConverter(item?.metadata?.price)}</td>
                                             </tr>
                                          </tbody>
                                       </table>
                                    </div>
                                 </div>
                              </div>
                              )
                           })}
                        </span>
                        <div className="p-2 bg-opacity-danger text-center fw-semibold text-danger ts-ssm">
                           Biaya Pengiriman {currencyConverter(detail?.pickup_fee)}
                        </div>
                        <div className="p-2 bg-gray text-center fw-semibold ts-md">
                           Total Pendapatan {currencyConverter(detail?.sub_total_price - detail?.pickup_fee)}
                        </div>
                        <div className="d-flex justify-content-between align-items-center w-100 mt-3">
                           <Button type="button" className="btn-sm rounded-pill me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => handleShowCancel()}>
                              Batalkan
                           </Button>
                           <Button type="button" className="btn-sm rounded-pill w-50" variant="success" onClick={() => handleShowConfirm()}>
                              Konfirmasi
                           </Button>
                        </div>
                     </div> :
                     <div className="text-secondary ts-sm text-center">
                        Tidak ada data keranjang
                     </div>
                  }
               </>   
            }
            </Card.Body>
         </Card>         
      </div>

      {detail ? 
            <Offcanvas show={showConfirm} onHide={handleCloseConfirm} placement="bottom" className="h-auto">
            <Offcanvas.Header closeButton>
               <Offcanvas.Title>Konfirmasi</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="py-4">
               <div className="pb-3">
                  <table className="table-listed">
                     <tbody>
                        <tr>
                           <td className="text-secondary" width="180px">Mitra</td>
                           <td className="text-body fw-semibold">{detail?.author?.name}</td>
                        </tr>
                        <tr>
                           <td className="text-secondary" width="180px">Sampah</td>
                           <td className="text-body fw-semibold">
                              <ul className="ps-3">
                                 {newsList.map((item, key)=>{
                                    return (
                                       <li key={key}>
                                          {item?.metadata?.attributes?.trash_type} - {item?.metadata?.attributes?.category_name} - {item?.metadata?.name} ({item?.metadata?.quantity} Kg)
                                       </li>
                                    )
                                 })}
                              </ul>
                           </td>
                        </tr>
                        <tr>
                           <td className="text-secondary" width="180px">Biaya Jemput</td>
                           <td className="text-body fw-semibold">{currencyConverter(detail?.pickup_fee)}</td>
                        </tr>
                        <tr>
                           <td className="text-secondary" width="180px">Total</td>
                           <td className="text-body fw-semibold">{currencyConverter(detail?.sub_total_price - detail?.pickup_fee)}</td>
                        </tr>
                     </tbody>
                  </table>
               </div>
               <div className="d-flex justify-content-between align-items-center w-100">
                  <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => handleCloseConfirm()}>
                     Batal
                  </Button>
                  <Button onClick={() => onConfirm()} className="rounded-pill py-2 w-50" variant="success">
                     Setuju
                  </Button>
               </div>
            </Offcanvas.Body>
         </Offcanvas>: null   
      }

      <Offcanvas show={showCancel} onHide={handleCloseCancel} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-4">
            <div className="my-3 text-center">
               <QuestionSvg/>
            </div>
            <div className="my-5">
               <div className="text-center">
                  Apakah Anda yakin ingin membatalkan setor sampah?
               </div>
            </div>

            <div className="d-flex justify-content-between align-items-center w-100">
               <Button type="button" className="rounded-pill py-2 me-3 w-50 d-flex align-items-center justify-content-center" variant="success-opacity" onClick={() => handleCloseCancel()}>
                  Batal
               </Button>
               <Button onClick={() => onCancel()} className="rounded-pill py-2 w-50" variant="success">
                  Setuju
               </Button>
            </div>
         </Offcanvas.Body>
      </Offcanvas>
   </Layout>
  );
}